import { Component, OnInit, } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { PortalHotToastService, setupUntilDestroy } from '@portal-workspace/grow-ui-library';
import { AddCreditFlowFn, GetCreditFlowsFn, UpdateCreditFlowFn, GetCreditAlertsFn, UpdateCreditAlertFn, AddCreditAlertFn, CopyCreditFlowFn, GetCreditRuleItemsFn, AddCreditRuleItemFn, UpdateCreditRuleItemFn, GetCreditAlertByStatusFn, TestCreditRuleFn, TestCreditFlowFn, TestCreditFlowNodeFn, TestCreditRuleItemFn, LocalApplicationDbReloadFn, GetActiveCreditUsersFn, UpdateCreditAssignableFn } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { ApplicationService } from '../../service/application.service';
import { CreditFlowsComponent, EditCreditFlowComponent } from '@portal-workspace/grow-ui-library';
import { Router } from '@angular/router';
import { navigationUrlForEditCreditFlow } from '../../service/navigation-urls';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CreditAlertsComponent } from '@portal-workspace/grow-ui-library';
import { CreditRuleItemsComponent } from '@portal-workspace/grow-ui-library';
import { LocalApplicationsDbService } from '../../service/local-applications-db.service';
import { CreditOfficersComponent } from '@portal-workspace/grow-ui-library';
import { AuthService } from '../../service/auth.service';

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
    templateUrl: './credit-management.page.html',
    styleUrls: ['./credit-management.page.scss'],
    standalone: true,
    imports: [MatCardModule, MatTabsModule, CreditRuleItemsComponent, CreditAlertsComponent, CreditFlowsComponent, MatTooltipModule, EditCreditFlowComponent, FlexModule, MatChipsModule, MatCheckboxModule, FormsModule, ReactiveFormsModule, MatDividerModule, MatFormFieldModule, MatInputModule, MatButtonModule, CreditOfficersComponent]
})
export class CreditManagementPage implements OnInit {
  addCreditFlowFn!: AddCreditFlowFn;
  getCreditFlowsFn!: GetCreditFlowsFn;
  updateCreditFlowFn!: UpdateCreditFlowFn;
  addCreditAlertFn!: AddCreditAlertFn;
  getCreditAlertsFn!: GetCreditAlertsFn;
  updateCreditAlertFn!: UpdateCreditAlertFn;
  copyCreditFlowFn!: CopyCreditFlowFn;
  getCreditRuleItemsFn!: GetCreditRuleItemsFn;
  addCreditRuleItemFn!: AddCreditRuleItemFn;
  updateCreditRuleItemFn!: UpdateCreditRuleItemFn;
  getCreditAlertByStatusFn!: GetCreditAlertByStatusFn;
  testCreditRuleFn!: TestCreditRuleFn;
  testCreditFlowFn!: TestCreditFlowFn;
  testCreditFlowNodeFn!: TestCreditFlowNodeFn;
  testCreditRuleItemFn!: TestCreditRuleItemFn;
  localApplicationDbReloadFn!: LocalApplicationDbReloadFn;
  getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  updateCreditAssignableFn!: UpdateCreditAssignableFn;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    private toastService: PortalHotToastService,
    private authService: AuthService,
    private localApplicationsDbService: LocalApplicationsDbService,
  ) {
    this.addCreditFlowFn = this.applicationService.addCreditFlowFn;
    this.getCreditFlowsFn = this.applicationService.getCreditFlowsFn;
    this.updateCreditFlowFn = this.applicationService.updateCreditFlowFn;
    this.addCreditAlertFn = this.applicationService.addCreditAlertFn;
    this.getCreditAlertsFn = this.applicationService.getCreditAlertsFn;
    this.updateCreditAlertFn = this.applicationService.updateCreditAlertFn;
    this.copyCreditFlowFn = this.applicationService.copyCreditFlowFn;
    this.getCreditRuleItemsFn = this.applicationService.getCreditRuleItemsFn;
    this.addCreditRuleItemFn = this.applicationService.addCreditRuleItemFn;
    this.updateCreditRuleItemFn = this.applicationService.updateCreditRuleItemFn;
    this.getCreditAlertByStatusFn = this.applicationService.getCreditAlertByStatusFn;
    this.testCreditRuleFn = this.applicationService.testCreditRuleFn;
    this.testCreditFlowFn = this.applicationService.testCreditFlowFn;
    this.testCreditFlowNodeFn = this.applicationService.testCreditFlowNodeFn;
    this.testCreditRuleItemFn = this.applicationService.testCreditRuleItemFn;
    this.localApplicationDbReloadFn = this.localApplicationsDbService.reloadFn;
    this.getActiveCreditUsersFn = this.applicationService.getActiveCreditUsers;
    this.updateCreditAssignableFn = this.authService.updateCreditAssignableFn;
  }


  ngOnInit(): void {
    setupUntilDestroy(this);
  }

  async addCreditFlow() {
    await this.router.navigate(navigationUrlForEditCreditFlow(0));
  }

  async onNavigateCreditFlow($event: number) {
    await this.router.navigate(navigationUrlForEditCreditFlow($event));
  }
}
